<form [formGroup]="codeTextForm">
    <div class="grid">
        <ui-page-title [showClose]="true" (onClose)="onCancel()" class="col" title="{{ formTitle }}" pageCode="{{ pageCodeModel.pageCode +'_U'}}"></ui-page-title>
    </div>
    <div class="p-fluid formgrid grid">
        <div *ngIf="routeName === 'payroll'" class="col-12">
            <hvl-form-item key="beginDate" class="col-12" label="{{ hrKey.hrCommon.beginDate | translate }}">
                <p-calendar
                    [required]="true"
                    id="{{ pageCodeModel.pageCode + '_beginDate' }}"
                    name="beginDate"
                    formControlName="beginDate"
                    [showIcon]="true"
                    #beginDate
                    [maxDate]="endDate?.value"
                    appendTo="body"
                    dateFormat="dd.mm.yy"
                ></p-calendar>
            </hvl-form-item>
            <hvl-form-item key="endDate" class="col-12" label="{{ hrKey.hrCommon.endDate | translate }}">
                <p-calendar
                    #endDate
                    [minDate]="beginDate?.value"
                    [required]="true"
                    [showIcon]="true"
                    appendTo="body"
                    id="{{ pageCodeModel.pageCode + '_endDate' }}"
                    name="endDate"
                    formControlName="endDate"
                    dateFormat="dd.mm.yy"
                ></p-calendar>
            </hvl-form-item>
        </div>
        <hvl-form-item class="col-4">
            @if(formMode === formModeEnum.EDIT) {
                <hvl-ml-dropdown
                    id="{{ pageCodeModel.pageCode + '_ddLanguageSelection' }}"
                    [placeHolder]="hrKey.common.buttonSelect | translate"
                    [form]="mlForm"
                    [selectedLanguage]="_selectedLanguageModel"
                    (formChangeEmitter)="formChangeDetected($event)"
                    (languageChangeEmitter)="languageChangeDetected($event)"
                ></hvl-ml-dropdown>
            }
        </hvl-form-item>
        <hvl-form-item name="code" [label]="hrKey.hrCommon.code | translate" class="col-12">
            <input id="code" type="text" formControlName="code" pInputText />
        </hvl-form-item>
        <div [formGroup]="mlForm" class="col-12">
            <hvl-form-item [showAsterisk]="true" class="col-12" key="shortText" label="{{ 'hrCommon.shortText' | translate }}">
                <input id="shortText" type="text" formControlName="shortText" pInputText (blur)="onDefinitionChange()" />
            </hvl-form-item>
            <hvl-form-item [showAsterisk]="true" class="col-12" key="longText" label="{{ 'hrCommon.longText' | translate }}">
                <input  id="longText" type="text" formControlName="longText" pInputText (blur)="onDefinitionChange()" />
            </hvl-form-item>
        </div>
        <hvl-form-item key="orderLevel" label="{{ hrKey.hrCommonCodeText.orderLevel | translate }}" class="col-10">
            <p-inputNumber [showButtons]="true" mode="decimal" min="0" [max]="99999" [maxFractionDigits]="0" formControlName="orderLevel"></p-inputNumber>
        </hvl-form-item>
        <hvl-form-item class="col-2" label="&nbsp;">
            <button
                id="{{pageCodeModel.pageCode + '_orderLevelFinder'}}"
                *ngIf="formMode !== formModeEnum.REMOVE"
                pButton
                class="mr-2 p-button-outlined"
                (click)="onFindNextOrderLevel()"
                title="{{ hrKey.hrCommonCodeText.findNextOrderLevel | translate }}"
            >
                <i class="material-icons">skip_next</i>
            </button>
        </hvl-form-item>
    </div>
    <ui-form-footer-buttons
        [form]="codeTextForm"
        [idPrefix]="pageCodeModel.pageCode"
        showCancel="true"
        [showSave]="!codeTextForm.disabled"
        [showRemove]="codeTextForm.disabled"
        (onCancel)="onCancel()"
        (onRemove)="onRemove()"
        (onSave)="onSave()"
    ></ui-form-footer-buttons>
</form>
